var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.stopLine))]),_c('div',[_vm._v(_vm._s(_vm.originalStopLine))]),_c('div',[_vm._v(_vm._s(_vm.addedAtLine))])])
}
var staticRenderFns = []

export { render, staticRenderFns }